// extracted by mini-css-extract-plugin
export default {"page":"vX-z","cartModal":"wX-z","checkout":"xX-z","placeholder":"yX-z","account":"zX-z"};